/* COPYRIGHT Esri - https://js.arcgis.com/5.1/LICENSE.txt */
function getRoundRobinIndex(index, total) {
  return (index + total) % total;
}
export {
  getRoundRobinIndex as g
};
